import { useSelector } from "react-redux";
import { RootState } from "../../redux/store/store";
import { EditDrawerState } from "../../redux/reducers/appReducer";

const useEditDrawerState = (): EditDrawerState => {
  const editDrawerState = useSelector(
    (state: RootState) => state.app.isEditDrawerOpen
  );
  return editDrawerState;
};

export default useEditDrawerState;
